import { BetPresets, SiteConfigs } from 'app/api/services/site-configs/types';

export type PresetItem = {
  type: 'presets';
  value: number;
};

export type TransformedSiteConfigs = Omit<SiteConfigs, 'betPresets'> & {
  betPresets?: PresetItem[];
};

export function transformPresetItem(presets?: BetPresets): PresetItem[] {
  if (!presets) {
    return [];
  }
  const presetsKeys = Object.keys(presets) as (keyof BetPresets)[];
  return presetsKeys.reduce((acc: PresetItem[], presetKey) => {
    if (presets[presetKey] <= 0) {
      return acc;
    }

    acc.push({
      type: 'presets',
      value: presets[presetKey],
    });

    return acc;
  }, []);
}
